import copy from 'copy-to-clipboard';

// import { multiAddEventListener, getRootOffsetBounds } from 'helpers';

export default class Share {
    constructor() {
        console.info('Share.constructor()');

        this.selector = '.button-share';
        this.container = document.querySelector('.button-share');

        this.config = {
            delay: {
                mouseLeave: 400,
            },
            window: {
                width: 600,
                height: 580,
            },
        };

        this.el = {
            container: this.container,
            button: this.container.querySelector(`${this.selector}__button-toggle`),
            buttonClipboard: this.container.querySelector(`${this.selector}__flyout-button-clipboard`),
            flyout: this.container.querySelector(`${this.selector}__flyout`),
            shareButtons: this.container.querySelectorAll(`${this.selector}__flyout-share-links li a`),
        };

        this.flags = {
            isActive: false,
            isDevMode: false, // disable rollout
            isToggleClick: false,
        };

        this.timeouts = {
            mouseLeave: null,
        };
    }

    init() {
        console.info('Share.init()');

        this.el.container.addEventListener('mouseenter', this.onMouseEnter);
        this.el.button.addEventListener('click', this.onClick);
        this.el.buttonClipboard.addEventListener('click', this.onClickClipboard); 
        
        this.el.shareButtons.forEach((button) => {
            button.addEventListener('click', this.onShareButtonClick);
        });
    }

    onMouseEnter = () => {
        this.open();
    };

    onMouseLeave = () => {
        if (!this.flags.isToggleClick) {
            this.addTimeout();
        }
    };

    onClick = () => {
        if (this.flags.isActive && this.flags.isToggleClick) {
            this.flags.isToggleClick = false;
            this.close();
        } else {
            this.flags.isToggleClick = true;
            this.open();
        }
    };

    onClickClipboard = () => {
        this.el.buttonClipboard.style.pointerEvents = 'none';

        copy(this.el.buttonClipboard.dataset.clipboardContent);

        alert("You've copied a link.");

        setTimeout(() => {
            this.el.buttonClipboard.style.pointerEvents = '';
        }, 3000);
    };

    onShareButtonClick = (e) => {
        e.preventDefault();
        const top = parseInt((window.innerHeight - this.config.window.height) / 2);
        const left = parseInt((window.innerWidth - this.config.window.width) / 2);
        const options = `width=${this.config.window.width}, height=${this.config.window.height}, top=${top}, left=${left}`;
        window.open(e.currentTarget.getAttribute('href'), e.currentTarget.dataset.service, options);

        if (CLWP_PC_GLOBAL.isLoggedIn) {
            if (Electro.ranchologyNonces.shareRecipe && this.el.container.dataset.postType === 'recipe') {
                Electro.submitActivity(
                    Electro.ranchologyNonces.shareRecipe,
                    Electro.ranchologyActivities.shareRecipe,
                    this.el.container.dataset.postId,
                    false,
                    false
                );
            } else if (Electro.ranchologyNonces.socialPost && this.el.container.dataset.postId) {
                Electro.submitActivity(
                    Electro.ranchologyNonces.socialPost,
                    Electro.ranchologyActivities.socialPost,
                    this.el.container.dataset.postId,
                    false,
                    false
                );
            }
        }
    };

    onBodyClick = (e) => {
        if (!this.el.container.contains(e.target)) {
            this.close();
        }
    };

    open = () => {
        this.removeTimeout();

        if (!this.flags.isActive) {
            this.flags.isActive = true;
            this.el.container.classList.add('is-active');

            if (!this.flags.isToggleClick && !this.flags.isDevMode) {
                this.el.button.addEventListener('mouseleave', this.onMouseLeave);
                this.el.flyout.addEventListener('mouseleave', this.onMouseLeave);
            }

            document.body.addEventListener('click', this.onBodyClick);
        }
    };

    close = () => {
        this.removeTimeout();

        if (this.flags.isActive) {
            this.flags.isActive = false;
            this.flags.isToggleClick = false;
            this.el.container.classList.remove('is-active');

            this.el.button.removeEventListener('mouseleave', this.onMouseLeave);
            this.el.flyout.removeEventListener('mouseleave', this.onMouseLeave);
            document.body.removeEventListener('click', this.onBodyClick);
        }
    };

    addTimeout() {
        if (!this.timeouts.mouseLeave) {
            this.timeouts.mouseLeave = setTimeout(() => {
                this.timeouts.mouseLeave = null;
                this.close();
            }, this.config.delay.mouseLeave);
        }
    }

    removeTimeout() {
        if (this.timeouts.mouseLeave) {
            clearTimeout(this.timeouts.mouseLeave);
            this.timeouts.mouseLeave = null;
        }
    }
}